export default "__VITE_ASSET__B3Oh035T__"